import { AxiosError } from "axios";
import { HttpErrorResponse } from "./types";
import {
  InvoiceUpdateHttpSuccessResponse,
  GetStockAvailabilityResponse,
  MerchantHttpSuccessResponse,
  StatementHTTPResponse,
  StatementPaylinkHTTPSuccessResponse,
} from "./statement-service/types";

const generateHttpError = (e: unknown): HttpErrorResponse => {
  // Check for an axios code that isn't our expected success code
  const status = (e as AxiosError).response?.status;
  const errorMessage = (e as AxiosError).response?.data;

  if (status !== undefined) {
    if (typeof errorMessage === "string") {
      return {
        success: false,
        statusCode: status,
        message: errorMessage,
      };
    }
    return {
      success: false,
      statusCode: status,
    };
  }
  return {
    success: false,
    statusCode: 500,
    message: "Please try again or contact support.",
  };
};

type AcceptableResponses =
  | StatementHTTPResponse
  | MerchantHttpSuccessResponse
  | StatementPaylinkHTTPSuccessResponse
  | InvoiceUpdateHttpSuccessResponse
  | GetStockAvailabilityResponse
  | HttpErrorResponse;

const isHttpErrorResponse = (data: AcceptableResponses): data is HttpErrorResponse => {
  return (data as HttpErrorResponse).success === false;
};

export { generateHttpError, isHttpErrorResponse };
